import { maintainResponseStructure } from '../../../util/util-common';

const payloadStructures = {
  attendee: {
    eventid: 0,
    firstname: '',
    lastname: '',
    username: '',
    profileurl: '',
    coverimage: '',
    frameurl: '',
    videourl: '',
    isnetworking: '',
    responses: null
  },
  exhibitor: {
    eventid: 0,
    name: '',
    about: '',
    profileimage: '',
    profilethumbimage: '',
    bannerimage: '',
    responses: null
  },
  sponsor: {
    eventid: 0,
    name: '',
    description: '',
    logoimgpath: '',
    logothumbimgpath: '',
    bannerimage: '',
    responses: null
  },
  speaker: {
    eventid: 0,
    firstname: '',
    lastname: '',
    position: '',
    company: '',
    country: '',
    description: '',
    email: '',
    facebook: '',
    googleplus: '',
    linkedin: '',
    twitter: '',
    phone: '',
    profileimage: '',
    profilethumbimage: '',
    file1: '',
    file2: '',
    file3: '',
    file4: '',
    file5: ''
  }
};

export const prepareFinalPayload = (eventid, type, values) => {
  let payloadValues = _.cloneDeep(payloadStructures[type]);

  _.map(payloadValues, (val, key) => {
    switch (key) {
      case 'eventid':
        payloadValues[key] = eventid;
        break;

      case 'responses':
        payloadValues[key] = JSON.stringify(
          maintainResponseStructure(checkImageValues(values[key]) ?? val)
        );
        break;

      default:
        payloadValues[key] = values[key] ?? val;
        break;
    }
  });

  return payloadValues;
};

const checkImageValues = responses => {
  let responseToCheck = _.cloneDeep(JSON.parse(responses));

  _.map(responseToCheck, field => {
    if (field?.key === 'file') {
      field.value = _.map(field?.value, fieldValue =>
        typeof fieldValue !== 'string' && fieldValue?.file
          ? fieldValue?.file
          : fieldValue
      );
    } else if (field?.key === 'group' && field?.type === 'products') {
      field.value = _.map(field?.value, fieldValue => {
        fieldValue.productimages =
          typeof fieldValue?.productimages !== 'string' &&
          fieldValue?.productimages?.file
            ? fieldValue?.productimages?.file
            : fieldValue?.productimages;
        return fieldValue;
      });
    }
  });

  return responseToCheck;
};
